import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

const styles = theme => ({
  root: {
    display:'flex', 
    direction:'row', 
    justifyContent:'space-between', 
    marginBottom: 32,
    marginTop: 16,
  },
  actions: {
    textAlign: 'right'
  },
  title: {

  }
});


const PageHeader = ({actions, children, classes}) => (
  <div className={classes.root}>
    <div className={classes.title}>
      {children}
    </div>
    <div className={classes.actions}>
      {actions}
    </div>
  </div>
);

PageHeader.propTypes = {
  left: PropTypes.element,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(PageHeader);


// WEBPACK FOOTER //
// ./src/components/PageHeader.js